"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParamModal = void 0;
const react_1 = require("react");
const useRouter_1 = require("./useRouter");
function useParamModal(param) {
    const { hasParam, removeParam, setParam, query } = (0, useRouter_1.useRouter)();
    const show = (0, react_1.useCallback)((value) => setParam(param, value), [param, setParam]);
    const hide = (0, react_1.useCallback)(() => removeParam(param), [param, removeParam]);
    const open = (0, react_1.useMemo)(() => hasParam(param), [hasParam, param]);
    const data = (0, react_1.useMemo)(() => query[param], [param, query]);
    return (0, react_1.useMemo)(() => ({ open, show, hide, data }), [open, show, hide, data]);
}
exports.useParamModal = useParamModal;
